import {useMemo} from "react";

import {pickFinancialCtaPromotion} from "../../promotion/helpers/pick_financial_cta_promotion";
import {useAppSelector} from "../../store/hooks";
import {ViewType} from "../../view_type/ViewType";

export function useApplicationFormPromotionInfo() {
    const viewType = useAppSelector((state) => state.viewType.current);
    const propertyPromotions = useAppSelector((state) => state.property.promotions);
    const propertyOfferPromotions = useAppSelector((state) => state.property.property?.offer.promotions);
    const offerDetailPromotions = useAppSelector((state) => state.offerDetail.promotions);

    // Order of priority according to KM-112
    return useMemo(() => {
        if (viewType === ViewType.PROPERTY) {
            return pickFinancialCtaPromotion(propertyPromotions, propertyOfferPromotions);
        }

        if (viewType === ViewType.OFFER) {
            return pickFinancialCtaPromotion(offerDetailPromotions);
        }

        return pickFinancialCtaPromotion(propertyPromotions, propertyOfferPromotions, offerDetailPromotions);
    }, [viewType, propertyPromotions, propertyOfferPromotions, offerDetailPromotions]);
}
import {useMemo} from "react";

import {pickFinancialCtaPromotion} from "../../promotion/helpers/pick_financial_cta_promotion";
import {useAppSelector} from "../../store/hooks";
import {ViewType} from "../../view_type/ViewType";

export function useApplicationFormPromotionInfo() {
    const viewType = useAppSelector((state) => state.viewType.current);
    const propertyPromotions = useAppSelector((state) => state.property.promotions);
    const propertyOfferPromotions = useAppSelector((state) => state.property.property?.offer.promotions);
    const offerDetailPromotions = useAppSelector((state) => state.offerDetail.promotions);

    // Order of priority according to KM-112
    return useMemo(() => {
        if (viewType === ViewType.PROPERTY) {
            return pickFinancialCtaPromotion(propertyPromotions, propertyOfferPromotions);
        }

        if (viewType === ViewType.OFFER) {
            return pickFinancialCtaPromotion(offerDetailPromotions);
        }

        return pickFinancialCtaPromotion(propertyPromotions, propertyOfferPromotions, offerDetailPromotions);
    }, [viewType, propertyPromotions, propertyOfferPromotions, offerDetailPromotions]);
}
